import request from '@/network/request.js';
import urls from '@/network/api.js';

const WEBSITE_INFO_KEY = 'WEBSITE_INFO';

export default {
  namespaced: true,
  state: () => ({
    info: JSON.parse(localStorage.getItem(WEBSITE_INFO_KEY)) || null,
  }),
  mutations: {
    SET_INFO(state, info) {
      state.info = info;
      localStorage.setItem(WEBSITE_INFO_KEY, JSON.stringify(info));
    },
  },
  actions: {
    async fetchInfo({ commit }) {
      try {
       const req = new request(urls.m().websiteInfos);
        const res = await req.modeget();
        commit('SET_INFO', res.data.data);
      } catch (error) {
        console.error('Failed to fetch website info:', error);
      }
    },
  },
  getters: {
    getInfo: (state) => state.info,
  },
};